import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import { LoginTab } from "./LoginTab";

import { useAppDispatch, useAppSelector } from "../../../hooks";
import { hasAuthorization } from "../../../helpers";
import { WebAppRole } from "../../../shared/types/collaborators.types";
import { startCheckingNew } from "../../../store/thunks/authThunks";

export const AuthPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();

  const { user } = useAppSelector((state) => state.authReducer);
  const role2 = user ? user.role : undefined;

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get("token");
    if (token) {
      localStorage.setItem("token", token);
      dispatch(startCheckingNew());
    }
  }, []);

  useEffect(() => {
    if (hasAuthorization(role2, WebAppRole.collaborator)) {
      return navigate("/dashboard", { replace: true });
    }

    if (hasAuthorization(role2, WebAppRole.user)) {
      return navigate("/clients", { replace: true });
    }
  }, [role2, navigate]);

  return (
    <Box
      sx={{
        minHeight: "calc(100vh - 200px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        py: { xs: 4, md: 8 },
        px: 2,
      }}
    >
      <LoginTab />
    </Box>
  );
};
